let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("k6Mgt")]).then(() => parcelRequire('6GeD6'));